import { Main } from './components/containers/Main';

const MinimumFees = () => <Main />;

export default MinimumFees;
